import * as React from 'react';

const SvgHome = props => (
  <svg
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 30V14.61a2 2 0 0 1 .709-1.527l13-10.991a2 2 0 0 1 2.582 0l13 10.99A2 2 0 0 1 32 14.61V30a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2v-5.595a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2V30a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2Z"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="square"
    />
  </svg>
);

export default SvgHome;
